import { Modal } from 'almanac-ui/Modal'
import styles from 'components/SecretIdentityModal/SecretIdentityModal.module.scss'
import cx from 'classnames'
import { heroImages, ImageKey } from 'components/SecretIdentityModal/identities'
import { Title } from 'almanac-ui/Title/Title'
import { SecretIdentityCard } from 'components/SecretIdentityModal/SecretIdentityCard/SecretIdentityCard'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Button } from 'blaze-ui/Button'

interface Props {
  onSelectImage: (imageKey: ImageKey) => void
  onPressOutside?: () => void
  onSkip: () => void
}

export const SelectAvatarModal = ({ onSelectImage, onPressOutside, onSkip }: Props) => {
  const { isMobile } = useResponsiveDesign()

  return (
    <Modal.Root
      size="lg"
      aria-labelledby="modal-title"
      onPressOutside={onPressOutside}
      wrapperClassName={styles.modalWrapper}
    >
      <div id="secret-identity-modal-body" className={styles.modalBody}>
        <div className={cx(styles.step, styles.step1, styles.active)}>
          <div className={styles.modalHeaderContainer}>
            <div className={styles.modalHeaderTitle}>
              <Title id="modal-title">CHOOSE YOUR {isMobile ? '' : 'SECRET'} IDENTITY</Title>
            </div>
          </div>
          <div className={styles.grid}>
            {Object.keys(heroImages).map((key) => (
              <SecretIdentityCard
                key={key}
                imageKey={key as ImageKey}
                onSelect={() => onSelectImage(key as ImageKey)}
              />
            ))}
          </div>
        </div>
        <div className={styles.skipButton}>
          <Button variant="tertiary" onPress={onSkip} size="lg">
            Skip
          </Button>
        </div>
      </div>
    </Modal.Root>
  )
}
